import type { FillerTile, OreTile, DepthZone } from '../types/tiles'

export const FILLER_TILES: FillerTile[] = [
  { id: 'dirt',      name: 'Dirt',      color: 0x8B6914, fuelCost: 1,  minDepth: 0,   maxDepth: 50  },
  { id: 'clay',      name: 'Clay',      color: 0xC67840, fuelCost: 2,  minDepth: 25,  maxDepth: 100 },
  { id: 'stone',     name: 'Stone',     color: 0x808080, fuelCost: 3,  minDepth: 50,  maxDepth: 200 },
  { id: 'hardrock',  name: 'Hard Rock', color: 0x5A5A5A, fuelCost: 5,  minDepth: 100, maxDepth: 400 },
  { id: 'basalt',    name: 'Basalt',    color: 0x3D3D3D, fuelCost: 8,  minDepth: 200, maxDepth: 800 },
  { id: 'granite',   name: 'Granite',   color: 0x6B4C3B, fuelCost: 12, minDepth: 400, maxDepth: Infinity },
]

export const ORE_TILES: OreTile[] = [
  { id: 'copper',   name: 'Copper',   color: 0xB87333, value: 8,    weight: 1, minDepth: 5,   rarityBp: 1500, fuelCost: 1 },
  { id: 'iron',     name: 'Iron',     color: 0xA19D94, value: 18,   weight: 2, minDepth: 20,  rarityBp: 1200, fuelCost: 1 },
  { id: 'silver',   name: 'Silver',   color: 0xC0C0C0, value: 45,   weight: 2, minDepth: 50,  rarityBp: 800,  fuelCost: 2 },
  { id: 'gold',     name: 'Gold',     color: 0xFFD700, value: 110,  weight: 3, minDepth: 100, rarityBp: 500,  fuelCost: 3 },
  { id: 'platinum', name: 'Cinnabar', color: 0xE5E4E2, value: 275,  weight: 3, minDepth: 200, rarityBp: 300,  fuelCost: 5 },
  { id: 'emerald',  name: 'Emerald',  color: 0x50C878, value: 700,  weight: 4, minDepth: 350, rarityBp: 150,  fuelCost: 7 },
  { id: 'ruby',     name: 'Ruby',     color: 0xE0115F, value: 1750, weight: 5, minDepth: 500, rarityBp: 80,   fuelCost: 10 },
  { id: 'diamond',  name: 'Diamond',  color: 0xB9F2FF, value: 4000, weight: 5, minDepth: 750, rarityBp: 30,   fuelCost: 12 },
]

export const DEPTH_ZONES: DepthZone[] = [
  { name: 'Topsoil',       minDepth: 0,   bgColor: 0x4A3728 },
  { name: 'Shallow Rock',  minDepth: 50,  bgColor: 0x3E3E3E },
  { name: 'Deep Rock',     minDepth: 100, bgColor: 0x2D2D2D },
  { name: 'Cavern Layer',  minDepth: 200, bgColor: 0x1E1E2E },
  { name: 'Magma Fringe',  minDepth: 400, bgColor: 0x2E1A1A },
  { name: 'Deep Mantle',   minDepth: 800, bgColor: 0x1A0A0A },
]
